import ImagePreviewModel from "crop-image/src/ImagePreviewModel";
import AlbumUpdateRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MusicService/AlbumUpdateRequest";
import AlbumGetDetailReponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MusicService/AlbumGetDetailReponse";
import MusicAudioViewModel from "./musicAudioViewModel";
import MusicTranslateViewModel from "./musicTranslateViewModel";
import MusicAudioTranslationViewModel from "./musicAudioTranslationViewModel";
import { mapToCropRequest } from "@/frameworks/imagePreviewModelMapper";

export default class CreateMusicViewModel {
    id?: number = null;
	isSleep: boolean = false;
	isPaid: boolean = false;
	useOnMainDisplay: boolean = false;
	animationId: string = null;
	animationUrl: string = null;
	audios: Array<MusicAudioViewModel> = [];
	translations: Array<MusicTranslateViewModel> = [];
	coverImage: ImagePreviewModel = new ImagePreviewModel();
	backgroundImage: ImagePreviewModel = new ImagePreviewModel();
	categoriesIds: Array<number> = null;
	get hasCoverImage(): boolean {
		const imageUrl = this.coverImage && this.coverImage.ImageUrl;
		return !!imageUrl && imageUrl !== '/assets/img/no_image.svg';
	}
	toServerModel(): AlbumUpdateRequest {
		const albumId = this.id || 0;
		const cover = this.hasNewImage(this.coverImage) ? mapToCropRequest(this.coverImage) : null;
		const back = cover ? { ...cover } : null;
		const req = new AlbumUpdateRequest({
			Id: this.id,
			IsSleep: this.isSleep,
			IsPaid: this.isPaid,
			UseOnMainDisplay: this.useOnMainDisplay,
			AnimationId: this.animationId,
			Back: back,
			Cover: cover,
			Translations: (this.translations || [])
				.filter(x => Boolean((x.name || '').trim()))
				.map(x=>x.toServerModel()),
			Audiofiles: (this.audios || [])
				.filter((audio) => audio.hasNewFile())
				.map((audio) => {
					audio.albumId = albumId;
					return audio.toServerModel();
				}),
			Categories: this.categoriesIds,
		});
		// this.audios.forEach(audioGroup => {
		// 	req.Translations.forEach(tr => {
		// 		if (!tr.VoiceFiles) {
		// 			tr.VoiceFiles = [];
		// 		}
		// 		const audios = audioGroup.audios.filter(x=>x.langCode == tr.LangCode);
		// 		if (audios.length > 0) {
		// 			tr.VoiceFiles.push(...(audios.map(a=>a.toServerModel())));
		// 		}
		// 	});
		// });
		return req;
	}
	hasNewImage(image: ImagePreviewModel): boolean {
		const imageUrl = image && image.ImageUrl;
		return !!imageUrl && imageUrl.indexOf('data:') === 0;
	}
	initLanguages(langs: string[]) {
		this.translations = langs.map(x=>new MusicTranslateViewModel({
			langCode: x
		}));
	}
	fromServerModel(model: AlbumGetDetailReponse) {
		this.id = model.Id;
		this.backgroundImage.ImageUrl = model.BackgroundUrl;
		this.coverImage.ImageUrl = model.CoverUrl;
		this.isPaid = model.IsPaid;
		this.isSleep = model.IsSleep;
		this.animationId = model.AnimationId;
		this.useOnMainDisplay = model.UseOnMainDisplay;
		const langs = this.translations.map(x => x.langCode);
		this.audios = (model.Audiofiles || []).map(x=> new MusicAudioViewModel({
			id: x.Id,
			albumId: model.Id,
			audioUrl: x.Url,
			isPaid: x.IsPaid,
			translations: langs.map(tr => new MusicAudioTranslationViewModel({
				langCode: tr
			}))
		}));
		
		this.categoriesIds = (model.Categories || []).map(x => x.Id);

		this.translations.forEach(tr => {
			const serverTranslation = (model.AlbumTranslations || []).find(x=>x.LangCode == tr.langCode);
			if (serverTranslation != null) {
				tr.name = serverTranslation.Name;
			}
		});

		this.audios.forEach((audio) => {
			const serverAudio = (model.Audiofiles || []).find(x=>x.Id == audio.id);
			if (serverAudio != null) {
				audio.translations.forEach(tr => {
					const serverTranslation = (serverAudio.AudiofileTranslations || []).find(f => f.LangCode == tr.langCode);
					if (serverTranslation != null) {
						tr.index = serverTranslation.Index;
						tr.name = serverTranslation.Name;
					}
				})
			}
		});
	}
}
